export default __webpack_public_path__ + "static/media/110.d02c194d.jpg";